import { isNonEmptyArray } from './is-non-empty-array.function';

/**
 * Returns true when `array` is a non-empty array that includes `value`.
 * @param array - Array value to search, often read from an untyped record.
 * @param value - Value to test for membership.
 * @param equals - Optional equality predicate; defaults to strict `===`.
 * @returns Whether the array contains `value`.
 * @example
 * arrayIncludesValue(['a', 'b'], 'a'); // true
 * arrayIncludesValue([], 'a'); // false
 * arrayIncludesValue(null, 'a'); // false
 */
export function arrayIncludesValue(
  array: unknown,
  value: unknown,
  equals: (item: unknown, searchValue: unknown) => boolean = (a, b) => a === b,
): boolean {
  return isNonEmptyArray(array) && array.some((item) => equals(item, value));
}
